import React, { useState } from "react";
//import _Select from "../../../../components/generic/_Select";
import _Button from "../../../generic/_Button";
import { DateFilters } from "../../../ui/Form/Period";
import { useMutation, useQuery } from "@tanstack/react-query";
import { httpClient } from "../../../../utils/HttpClient";
import { ApiEndpoint } from "../../../../utils/ApiEndpoint";
import { useAuth } from "../../../../Context/AuthContext";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ErrorMessage } from "../../../../utils/toastify";
import { today } from "../../../../utils/dateHelpers";
import TablePartners from "./TablePartners";
import { Spinner } from "react-bootstrap";
import { NotContent } from "../../../ui/Form";
import { SelectAndSearch } from "../../../ui/Form/SelectAndSearch";
import { errorLabels } from "../../../../utils/helpers";
const _ConciliationExternalCampaign = () => {
  const auth = useAuth();
  const { token } = auth.getSessionData();
  const [smrybyexternal, setSmrybyexternal] = useState([]);
  const CLEVERTAP = 5;

  const formik = useFormik({
    initialValues: {
      period: {
        dateFrom: today("YYYY/MM/DD"),
        dateTo: today("YYYY/MM/DD"),
      },
      partner: "",
    },
    validationSchema: Yup.object({
      period: Yup.object({
        dateFrom: Yup.string().required("La fecha de inicio es requerida"),
        dateTo: Yup.string().required("La fecha de fin es requerida"),
      }),
      partner: Yup.string().required("El partner es requerido"),
    }),
    onSubmit: (values) => {
      mutate(values);
    },
  });

  const { data: partnerList } = useQuery({
    queryKey: ["partnersList"],
    queryFn: async () => {
      const response = await httpClient(
        "GET",
        `${ApiEndpoint}partners/${CLEVERTAP}`,
        {},
        token,
      );

      return response.data;
    },
    initialData: [],
    refetchOnWindowFocus: false,
  });

  const { mutate, isPending: isLoadingCampaings } = useMutation({
    mutationKey: ["campaigns"],
    mutationFn: async (values) => {
      const response = await httpClient(
        "post",
        `${ApiEndpoint}adminreports/concbyexternalid
`,
        {
          from: values.period.dateFrom,
          to: values.period.dateTo,
          partneruid: values.partner,
        },
        token,
      );

      return response.data;
    },
    onSuccess: (data) => {
      setSmrybyexternal(data);
    },
  });

  const _validate = async () => {
    try {
      const isValid = await formik.validateForm();
      const errors = errorLabels(isValid);

      if (Object.keys(isValid).length !== 0) {
        throw new Error(`Campos inválidos: ${errors}`);
      }
      await formik.submitForm();
    } catch (error) {
      ErrorMessage(error.message);
    }
  };

  const renderContent = () => {
    if (isLoadingCampaings) {
      return (
        <div className="w-full min-h-[60vh] flex justify-center items-center">
          <Spinner animation="border" />
        </div>
      );
    }

    if (!smrybyexternal.length) {
      return (
        <div className="w-full min-h-[60vh] flex justify-center items-center">
          <NotContent />
        </div>
      );
    }

    return (
      <div className="bg-white rounded-lg px-4 py-2 mt-4">
        <TablePartners data={smrybyexternal} source="conciliation" />
      </div>
    );
  };

  return (
    <div>
      <div className="bg-white rounded-lg px-4 py-2">
        <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-2 ">
          <SelectAndSearch
            handleChange={(e) => {
              formik.setFieldValue("partner", e);
            }}
            values={formik.values.partner}
            options={partnerList.map((partner) => ({
              value: partner.uidpartner,
              label: partner.name,
            }))}
            placeholder="Selecciona un partner"
            errors={
              formik.errors && formik.errors.partner
                ? formik.errors.partner
                : ""
            }
            isError={formik.errors && formik.errors.partner}
            title="Partner"
            required
          />

          <DateFilters
            required
            setFilterFrom={(e) => formik.setFieldValue("period.dateFrom", e)}
            setFilterTo={(e) => formik.setFieldValue("period.dateTo", e)}
            errors={formik.errors}
            isClean={formik.values.period.dateFrom === ""}
          />
        </div>
        <div className="gap-2 grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2">
          <div>
            <_Button
              icon="clear_all"
              onClick={() => {
                formik.resetForm();
              }}
              disabled={isLoadingCampaings}
              loading={isLoadingCampaings}
              style="none"
              title="Limpiar"
              className="w-full"
            />
          </div>
          <div>
            <_Button
              icon="analytics"
              onClick={async () => await _validate()}
              style="primary"
              title="Generar reporte"
              disabled={isLoadingCampaings}
              loading={isLoadingCampaings}
              className="w-full"
            />
          </div>
        </div>
      </div>

      {renderContent()}
    </div>
  );
};

export default _ConciliationExternalCampaign;
